import RegisterPage from '../pages/RegisterPage';
import MobileAuthWrapper from '../pages/MobileAuthWrapper';

export default function MobileRegister() {

  return (
    <MobileAuthWrapper>
      <RegisterPage />
    </MobileAuthWrapper>
  );
}